import type { DataTypes } from 'fitify-ui-landing/src/@types'
import WorkStatisticsItem from 'fitify-ui-landing/src/components/blocks/WorkStatistics/WorkStatisticsItem'
import Container from 'fitify-ui-landing/src/components/Container/Container'
import Section from 'fitify-ui-landing/src/components/Section/Section'
import { Text } from 'fitify-ui-landing/src/components/Text'
import { useTranslation } from 'next-i18next'

import {
  StyledWorkStatistics,
  StyledWorkStatisticsGrid,
} from './WorkStatistics.Styled'

const WorkStatistics = ({
  items,
  headline,
  note,
}: {
  items: DataTypes.WorkStatisticItem[]
  headline: string
  note: string
}) => {
  const { t } = useTranslation()

  return (
    <Section>
      <Container>
        <StyledWorkStatistics>
          <Text
            as={'h2'}
            variant={'work-statistics-title'}
            html={t(headline)}
          />
          <StyledWorkStatisticsGrid>
            {items.map((item, index) => {
              return (
                <WorkStatisticsItem
                  key={index}
                  icon={item.icon}
                  iconColor={item.iconColor}
                  percent={item.percent}
                  content={item.content}
                />
              )
            })}
          </StyledWorkStatisticsGrid>
          <Text
            as={'p'}
            variant={'work-statistics-note'}
            color={'Blue400'}
            html={t(note)}
          />
        </StyledWorkStatistics>
      </Container>
    </Section>
  )
}

export default WorkStatistics
